var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStage1Top(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 190.446,
    height: 211.831,
    viewBox: "0 0 190.446 211.831",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7050",
    "data-name": "Rectangle 7050",
    width: 190.446,
    height: 211.831,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_44144",
    "data-name": "Group 44144",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11599",
    "data-name": "Path 11599",
    d: "M184.789,210.223c-.447,1.577-.836,6.042-1.457,11.831-.552,5.2-5.873,24.545-6.431,26.5-3.507,12.373-11.115,22.732-18.987,23.941-8.923,1.372-24.24,5.027-29.809,10.842-.115.121-.226.247-.336.378-4.858,5.832-7.025,15.564-17.583,16.721-10.564-1.151-12.73-10.884-17.589-16.721-.11-.132-.226-.263-.352-.389-5.573-5.8-20.874-9.459-29.792-10.831-7.877-1.209-15.485-11.058-18.992-23.436a52.192,52.192,0,0,1-1.341-6.011c-.557-3.439-4.533-15.8-5.084-21-.621-5.789-1.015-10.254-1.462-11.831-.752-2.655,36.433.326,74.613,4.065,38.174-3.738,75.354-6.72,74.6-4.065",
    transform: "translate(-15.062 -88.606)",
    fill: "#d3b1a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11600",
    "data-name": "Path 11600",
    d: "M182.7,227.085l-5,17.089s-2.629,9.2-4.469,13.934-15.512,13.408-19.192,18.929-13.214,9.055-22.378,13.861c-.379.2-.778.384-1.2.558-4.122,1.688-10.443,2.319-16.432,2.482-5.989-.163-12.309-.794-16.432-2.482-.426-.174-.826-.357-1.2-.558-9.165-4.806-18.7-8.339-22.378-13.861s-17.352-14.2-19.192-18.929-4.469-13.934-4.469-13.934l-5-17.089,68.671,5.674Z",
    transform: "translate(-19.21 -96.177)",
    fill: "#efcabf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11601",
    "data-name": "Path 11601",
    d: "M186.128,81.983C178.476,34.021,152.242.043,103.675.043h-.007C102.827.017,101.983,0,101.133,0,52.566,0,26.332,33.98,18.68,81.941c-5.5,34.485,22.568,74.089,22.568,74.089s13.807-7.855,26.81-3.13,14.219,21.4,31.9,22.033c.19.007.383.013.577.016,1.025.031,2.072.051,3.166.051a25.736,25.736,0,0,0,3.3-.21c16.04-.96,16.977-17.21,29.441-21.89s22.921,2.983,27.063,0c1.768-2.286,5.663-7.448,5.663-7.448s21.718-33.641,16.958-63.47",
    transform: "translate(-7.25 0)",
    fill: "#060606"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11602",
    "data-name": "Path 11602",
    d: "M299.375,197.812s11.42-6.172,11.42,0-10.517,18.6-13.671,23.429-10.333,3.032-10.333,3.032Z",
    transform: "translate(-120.35 -82.617)",
    fill: "#e5bfb1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11603",
    "data-name": "Path 11603",
    d: "M11.42,2.743S0-3.429,0,2.743s10.516,18.6,13.671,23.43S25.72,33.605,25.72,33.605Z",
    transform: "matrix(0.998, 0.07, -0.07, 0.998, 1.632, 105.06)",
    fill: "#e5bfb1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStage1Top);
export default __webpack_public_path__ + "static/media/stage1_top.5234aab8b1edc6d6b031f4ebcf3a68eb.svg";
export { ForwardRef as ReactComponent };